import store from '../data/store/store';

/*
    Gets the fallback value for birthday Calendar option
*/
export default function getBirthdayCalendarInitialState() {
    return store().birthdayCalendarEnabledInitial;
}
